import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { colors } from '../../utils/designSystem';

const TypingIndicator: React.FC = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2.5,
        py: 1.5,
        bgcolor: colors.gray[50],
        borderRadius: '4px 20px 20px 20px',
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      {/* Three-dot animation */}
      <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              bgcolor: colors.primary[400],
              animation: 'bounce 1.4s infinite ease-in-out',
              animationDelay: `${i * 0.16}s`,
              '@keyframes bounce': {
                '0%, 80%, 100%': {
                  transform: 'translateY(0)',
                  opacity: 0.4,
                },
                '40%': {
                  transform: 'translateY(-4px)',
                  opacity: 1,
                },
              },
            }}
          />
        ))}
      </Box>

      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          fontSize: '0.875rem',
        }}
      >
        Analyzing...
      </Typography>
    </Paper>
  );
};

export default TypingIndicator;
